import React from 'react'
import BEM from '@iui-kit/utils/bem'

const bem = new BEM(require('./Row.css'))

interface Props {
  children: React.ReactNode
}

const Row: React.FC<Props> = ({ children }: Props) => {
  return <div className={bem.b('Row').show()}>{children}</div>
}

export default Row
